import * as t from './actionTypes';
import { Action, State, CatalogPreviewResponseAction, CatalogPreviewErrorAction } from './types';

export const initialState: State['catalogs']['catalogPreviews'] = {
  catalogPreviews: [],
  isLoading: false,
  isError: false,
};

export const catalogPreviewReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case t.CATALOG_PREVIEW_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case t.CATALOG_PREVIEW_ERROR:
      return {
        ...state,
        error: (action as CatalogPreviewErrorAction).error,
        isLoading: false,
      };
    case t.CATALOG_PREVIEW_RESPONSE:
      return {
        ...state,
        catalogPreviews: (action as CatalogPreviewResponseAction).catalogPreviews,
        isLoading: false,
      };
    default:
      return state;
  }
};
